import { formatMoney, formatQty } from './money';
import { normalizePhone } from './validators';
import { formatOrderNumber, DELIVERY_TYPE_LABELS, type DeliveryTypeKey } from './orders';
import { PAYMENT_METHOD_LABELS, type PaymentMethodTypeKey } from './settings';

/** Link wa.me com mensagem pré-preenchida. Sem telefone abre a escolha de contato. */
export function whatsappLink(phone: string | null | undefined, text?: string): string {
  const p = normalizePhone(phone ?? '');
  const base = p ? `https://wa.me/${p}` : 'https://wa.me/';
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
}

export interface WhatsappOrderMessageInput {
  storeName: string;
  orderNumber?: number | null;
  customerName?: string | null;
  items: { quantity: number; unit?: string; name: string; variantName?: string | null; totalCents: number }[];
  subtotalCents: number;
  discountCents?: number;
  couponCode?: string | null;
  deliveryFeeCents?: number;
  totalCents: number;
  deliveryType?: DeliveryTypeKey;
  address?: string | null;
  paymentMethod?: PaymentMethodTypeKey | null;
  changeForCents?: number | null;
  notes?: string | null;
  trackingUrl?: string | null;
}

/** Mensagem de pedido formatada para WhatsApp (negrito com *asteriscos*). */
export function buildWhatsappOrderMessage(o: WhatsappOrderMessageInput): string {
  const lines: string[] = [];
  lines.push(
    o.orderNumber ? `*Pedido ${formatOrderNumber(o.orderNumber)} · ${o.storeName}*` : `*Novo pedido · ${o.storeName}*`,
  );
  if (o.customerName) lines.push(`Cliente: ${o.customerName}`);
  lines.push('');
  for (const it of o.items) {
    const variant = it.variantName ? ` (${it.variantName})` : '';
    lines.push(`• ${formatQty(it.quantity, it.unit)}x ${it.name}${variant}: ${formatMoney(it.totalCents)}`);
  }
  lines.push('');
  lines.push(`Subtotal: ${formatMoney(o.subtotalCents)}`);
  if (o.discountCents) lines.push(`Desconto${o.couponCode ? ` (${o.couponCode})` : ''}: -${formatMoney(o.discountCents)}`);
  if (o.deliveryFeeCents) lines.push(`Entrega: ${formatMoney(o.deliveryFeeCents)}`);
  lines.push(`*Total: ${formatMoney(o.totalCents)}*`);
  if (o.deliveryType && o.deliveryType !== 'none') {
    lines.push('');
    lines.push(`Entrega: ${DELIVERY_TYPE_LABELS[o.deliveryType]}`);
    if (o.address) lines.push(`Endereço: ${o.address}`);
  }
  if (o.paymentMethod) {
    lines.push(`Pagamento: ${PAYMENT_METHOD_LABELS[o.paymentMethod]}`);
    if (o.paymentMethod === 'cash' && o.changeForCents) lines.push(`Troco para: ${formatMoney(o.changeForCents)}`);
  }
  if (o.notes) {
    lines.push('');
    lines.push(`Obs.: ${o.notes}`);
  }
  if (o.trackingUrl) {
    lines.push('');
    lines.push(`Acompanhe: ${o.trackingUrl}`);
  }
  return lines.join('\n');
}
